import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import {
  MenuItem,
  MenuItemProps,
} from '@/components/poppers/MenuPopper/MenuItem';
import { useReportError } from '@/hooks/useReportError';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { ROUTE_KEYS } from '@/navigation/constants';

import { useDuplicateEntityMutation } from '../graphql/Entities.generated';

export interface DuplicateEntityMenuItemProps extends Partial<MenuItemProps> {
  label: string;
  householdId: string;
  entityId: string;
  onAfterCreate?: (entityId: string) => void;
}

export function DuplicateEntityMenuItem({
  householdId,
  entityId,
  onAfterCreate,
  ...buttonProps
}: DuplicateEntityMenuItemProps) {
  const trackUserEvent = useTrackUserEvent();
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();
  const { navigate } = useNavigateToRoute();
  const [duplicateEntity, { loading }] = useDuplicateEntityMutation({
    variables: { id: entityId },
    onError: (error) => {
      reportError(`failed to duplicate entity`, error);
      showFeedback(
        'Failed to duplicate this entity. Please refresh the page and try again.'
      );
    },
    onCompleted: (data) => {
      trackUserEvent('entity duplicated');
      if (onAfterCreate) {
        onAfterCreate(data.duplicateEntity.id);
      } else {
        navigate(ROUTE_KEYS.HOUSEHOLD_ENTITY_DETAILS, {
          householdId,
          entityId: data.duplicateEntity.id,
        });
      }
    },
  });

  return (
    <MenuItem
      loading={loading}
      onClick={() => duplicateEntity()}
      {...buttonProps}
    />
  );
}
